export default "__VITE_ASSET__B0FJvjPm__"